











































































































































































export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/warning-right-bottom/index.vue"
}
